import React from "react";

const ChartContext = React.createContext(null);

ChartContext.displayName = "ChartContext";

export function withChartInstance(Component) {
    const Com = React.forwardRef(((props, ref) => React.createElement(ChartContext.Consumer, null, (ctx => React.createElement(Component, Object.assign({}, props, {
        chart: ctx.chart
    }, ref ? {
        ref: ref
    } : {}))))));
    return Com.displayName = Component.displayName || Component.name, Com;
}

export default ChartContext;
//# sourceMappingURL=chart.js.map
